import { Inject, Injectable } from "@angular/core";
import { IEnvironmentConfig } from "../../shared/interfaces/IEnvironmentConfig";

@Injectable({
  providedIn: "root",
})
export class OrthoFiRoutingService {
  constructor(@Inject("ENV") private _env: IEnvironmentConfig) {}

  public getEligibilityCheckSummary(
    patientExamId: number,
    insurancePolicyPatientEligibilityId: number
  ): string {
    return `${this._env.portalUrl}/InsuranceEligibility/Multiple/${patientExamId}#/summary/${insurancePolicyPatientEligibilityId}`;
  }
}
